import React from "react";
import { ReactSVG } from "react-svg";
import imageRegistry from "../../constants/imageRegistry";
import CustomHeader from "./CustomHeader";

const AlertToaster = ({ titleBold,titleNormal, toasterLogo, containerClass, headerClass }) => {
  return (
      <div className={`step__alert-box ${containerClass}`}>
          <ReactSVG src={toasterLogo || imageRegistry.InfoLogo}/>
          <p><b>{titleBold}</b> {titleNormal}</p>

      </div>
  );
};

export default AlertToaster;
